/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
export class JouleUtils {
    static showDigitalAssistant() {
        console.log('Launching Joule....');
        if (window?.sap?.das?.webclient) {
            window.sap.das.webclient.show();
            console.log('Launched Joule');
        } else {
            console.log('Joule Client Not Found');
            console.log('Joule Client Loading script...');
            let url = 'https://fre-joule-6ls08978.eu12.sapdas.cloud.sap/resources/public/webclient/bootstrap.js';
            if (window.location.hostname === 'deploymenthub.cloud.sap') {
                // Change the PROD Instance URL
                url = 'https://fre-joule-6ls08978.eu12.sapdas.cloud.sap/resources/public/webclient/bootstrap.js';
            }
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            script.setAttribute('data-bot-name', 'helloworld');
            script.setAttribute('data-expander-type', 'CUSTOM');
            script.setAttribute(
                'data-expander-preferences',
                'JTdCJTIyYWNjZW50Q29sb3IlMjIlM0ElMjIlMjNFMDVBNDclMjIlMkMlMjJiYWNrZ3JvdW5kQ29sb3IlMjIlM0ElMjIlMjNGRkZGRkYlMjIlMkMlMjJjb21wbGVtZW50YXJ5Q29sb3IlMjIlM0ElMjIlMjNGRkZGRkYlMjIlMkMlMjJvbmJvYXJkaW5nTWVzc2FnZSUyMiUzQSUyMkNvbWUlMjBzcGVhayUyMHRvJTIwbWUhJTIyJTJDJTIyZXhwYW5kZXJUaXRsZSUyMiUzQSUyMiUyMiUyQyUyMmV4cGFuZGVyTG9nbyUyMiUzQSUyMkNVWF9BdmF0YXIuc3ZnJTIyJTJDJTIydGhlbWUlMjIlM0ElMjJzYXBfaG9yaXpvbiUyMiU3RA=='
            );
            script.addEventListener('load', function () {
                console.log('Joule Client Loaded');
                if (window?.sap?.das?.webclient) {
                    window.sap.das.webclient.show();
                } else {
                    console.log('Joule Client Not Found After Load');
                }
            });
            document.getElementsByTagName('head')[0].appendChild(script);
        }
    }
    static hideDigitalAssistant() {
        if (window?.sap?.das?.webclient) {
            window.sap.das.webclient.hide();
        }
    }
}
